var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('img',{attrs:{"src":require("../assets/logo.png"),"alt":"Logo Click"},on:{"click":function($event){return _vm.toHome()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }